// https://vue-i18n.intlify.dev/guide/essentials/started.html

export default {
  welcomeLogin: "欢迎登录环岛中港通票务系统",
  login: "ccc",
  user: { name: "{name}你好" },
  // testTip: "使用${tag}的方式插入标签(tag为具体的字段值)",
  testTip: "使用{'${tag}'}的方式插入标签(tag为具体的字段值)",
};

// <div>{{ $t("user.name", { name: bb }) }}</div>
//
